export type IconProps = {
  className?: string;
  height?: number;
  width?: number;
  tooltip?: string;
}

export function getWrapperClassName(className: Nullable<string>, classes: string): string {
  return className && className !== '' ? `${ className } ${ classes }` : classes
}
